import CalendarType from 'common/enums/calendarTypes';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { useCallback } from 'react';
import { editAvailabilityAction, fetchAvailabilitiesAction } from 'redux/slices/iCalendarV4/availabilitySlice';
import { closeNestedDialogAction } from 'redux/slices/nestedDialogSlice';
import MyAvailabilityForm from './MyAvailabilityForm';

const MyAvailabilityEdit = ({ availability, userData }) => {
    const { userGroupId } = userData;

    const { t } = useTranslation();
    const dispatch = useDispatch();

    const loadData = useCallback(() => {
        dispatch(
            fetchAvailabilitiesAction({
                queryParams: {
                    calendarId: userData.userId,
                    expand: ['services'],
                },
            }),
        );
    }, [dispatch, userData.userId]);

    const handleSubmit = (payload, callbackOk, callbackError) => {
        dispatch(
            editAvailabilityAction({
                id: availability.id,
                dto: payload,
                options: { useState: false },
                onSuccess: () => {
                    loadData();
                    callbackOk?.();
                    close();
                },
                onFailure: () => callbackError?.(),
            }),
        );
    };

    const close = () => {
        dispatch(closeNestedDialogAction());
    };

    return (
        <MyAvailabilityForm
            availability={availability}
            type={CalendarType.AGENT}
            onSubmit={handleSubmit}
            title={t('profile.myAvailability.form.editTitle')}
            edit={true}
            onClose={close}
            userGroupId={userGroupId}
        />
    );
};

export default MyAvailabilityEdit;
